<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
					پروفایل کاربری
					<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
			</div>
			<div class="" data-card-height="150" style="-webkit-transform: translate3d(0, 0, 0); background-size: cover; border: 0px !important; max-height: 150000px; margin-bottom: 30px; background-position: center center !important; z-index: -1; top: 0px; position: absolute; left: -8px; right: -8px; overflow: hidden; border-bottom-left-radius: 45px; border-bottom-right-radius: 45px;">
				<div style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1; opacity: 0.95; background-color: #4a89dc !important;"></div>
				<div class="dark-mode-tint" style="background-position: center center; background-size: cover !important; left: 0px; right: 0px; top: 0px; bottom: 0px; position: absolute; z-index: 1;"></div>
				<div style="background-image: url(/assets/Images/pictures/20.jpg); background-position: center center; background-repeat: no-repeat; position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; background-size: cover; z-index: 0;"></div>
			</div>
			<div class="card card-style mb-3">
				<div class="content">
					<div class="d-flex">
						<div class="d-flex align-items-center">
							<i class="fa fa-user-circle color-green1-dark fa-5x icon-size"></i>
						</div>
						<div class="d-flex flex-column justify-content-start">
							<h1 class="my-1 font-weight-bolder font-18">{{userModel.title}}</h1>
							<p class="font-16 font-weight-bold">کاربر تسکینو</p>
						</div>
					</div>

				</div>
			</div>
			<div class="card card-style">
				<div class="content mb-0">
					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active' : userModel.title!==null}">نام و نام خانوادگی</span>
						<input class="form-control" type="text" v-model="userModel.title" readonly>
					</div>

					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active' : userModel.phoneNumber!==null}">شماره تلفن همراه</span>
						<input class="form-control ltr text-left" type="text" v-model="userModel.phoneNumber" :readonly="userModel.phoneNumberValidated==true">
						<p @click="GetRegistCode()" v-if="userModel.phoneNumberValidated!=true && userModel.phoneNumber!=null && userModel.phoneNumber!='' && isNullPhoneNumber==false" class="mt-3 font-14 text-justify">
							<i class='fa fa-exclamation-triangle text-warning font-18 ml-1'></i>
							شماره تلفن همراه اعتبارسنجی نشده است. جهت اعتبارسنجی و دریافت اعلانها از طریق SMS
							<strong class="text-warning">اینجا</strong>
							کلیک کنید.
						</p>
					</div>

					<div class="mt-2 mb-0" v-if="showRegistCode">
						<p class="font-14 text-justify">لطفا کد ارسال شده به شماره <strong>{{userModel.phoneNumber}}</strong> را وارد کنید.</p>
						<div class="input-style input-style-2 has-icon input-required mt-4">
							<i class="input-icon fa fa-lock"></i>
							<span class="color-highlight input-style-1-active input-style-1-inactive">کد فعالسازی</span>
							<input type="tel" v-model="registCode">
							<p class="text-danger" v-if="invalidRegistCode">لطفا کد فعالسازی را وارد کنید</p>
						</div>
						<button disabled id="resendButton" class="text-right btn btn-default font-14 font-weight-bold w-100 text-center" @click.prevent="GetRegistCode" type="button"><i class="fa fa-check font-10 ml-2"></i>ارسال مجدد کد</button>
						<button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-mint-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="ValidateCode"><i class="fa fa-check font-10 ml-2"></i>ثبت کد فعالسازی</button>

					</div>


					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight" :class="{'input-style-1-active' : userModel.emailAddress!==null}">آدرس ایمیل</span>
						<input class="form-control ltr text-left" type="text" v-model="userModel.emailAddress" @input="v$.userModel.emailAddress.$touch()" :class="{invalid:v$.userModel.emailAddress.$error}" :readonly="userModel.emailValidated==true">
						<p class="text-danger" v-if="v$.userModel.emailAddress.email.$invalid && v$.userModel.emailAddress.$dirty">آدرس ایمیل نا معتبر می باشد.</p>
						<p @click="SendResetEmail()" v-if="userModel.emailValidated!=true && userModel.emailAddress!=null && userModel.emailAddress!='' && isNullEmail==false" class="mt-3 font-14 text-justify">
							<i class='fa fa-exclamation-triangle text-warning font-18 ml-1'></i>
							آدرس ایمیل اعتبارسنجی نشده است. جهت اعتبارسنجی و دریافت اعلانها از طریق ایمیل
							<strong class="text-warning">اینجا</strong>
							کلیک کنید.
						</p>
					</div>

					<div class="col-8">
						<div class="fac fac-checkbox " :class="userModel.phoneNumberValidated!=true?'fac-default':'fac-orange'">
							<span></span>
							<input id="box1-fac-checkbox" type="checkbox" v-model="userModel.smS_Notification" :disabled="userModel.phoneNumberValidated!=true">
							<label for="box1-fac-checkbox">ارسال SMS</label>
						</div>
					</div>
					<div class="col-8">
						<div class="fac fac-checkbox" :class="userModel.emailValidated!=true?'fac-default':'fac-orange'">
							<span></span>
							<input id="box2-fac-checkbox" type="checkbox" v-model="userModel.email_Notification" :disabled="userModel.emailValidated!=true">
							<label for="box2-fac-checkbox">ارسال ایمیل</label>
						</div>
					</div>
					<div class="col-8">
						<div class="fac fac-checkbox fac-orange">
							<span></span>
							<input id="box3-fac-checkbox" type="checkbox" v-model="userModel.mobile_Notification">
							<label for="box3-fac-checkbox">ارسال نوتیفیکیشن موبایل</label>
						</div>
					</div>
					<!-- <div class="col-6">
					<div class="fac fac-checkbox fac-red">
						<span></span>
						<input id="box6-fac-checkbox" type="checkbox" v-model="userModel.disabled">
						<label for="box6-fac-checkbox">غیرفعال</label>
					</div>
				</div> -->

					<button :disabled="Loading" class="btn btn-xxs mt-4 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateLocaluserList">
						<i class="fa fa-check font-10 ml-2"></i>
						ثبت
					</button>
				</div>
			</div>
		</div>

		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
			</div>
		</transition>
		<Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
		<!--<div id="userProfileHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>

					<div class="card-bg bg-20"></div>
				</div>
				<div class="card card-style">
					<div class="content mt-0 pb-2">
						<div class="list-group list-custom-small list-icon-0 mt-3 border-b">
							<div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
								<i class="fa font-14 fa-info-circle color-magenta1-light"></i>
								<span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
								<i class="fa fa-angle-down line-height-xl"></i>
							</div>
						</div>
						<div class="collapse border-b pb-3" id="collapse-0" style="">
							<div class="d-flex justify-content-center">
								<video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
									<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-UserProfile.mp4" type="video/mp4">
								</video>
							</div>
							<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-UserProfile.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
						</div>
					</div>
				</div>
			</div>
		</div>-->
	</div>
</template>
<script>
	import useVuelidate from '@vuelidate/core'
	import {
		email
	} from "@vuelidate/validators";
	import 'vue-select/dist/vue-select.css';
    import HelpMenu from '../Components/HelpMenu.vue';
	import VueSimpleAlert from "vue3-simple-alert";

	export default {
		setup: () => ({ v$: useVuelidate() }),
        components: {
            "Help-Menu": HelpMenu
        },
		data() {
			return {
				testData: null,
				registCode: null,
				invalidRegistCode: false,
				showRegistCode: false,
				isNullEmail:true,
				isNullPhoneNumber:true,
				userModel: {
					userCode: "",
					title: null,
					orgJobTitle: 0,
					orgJobId: 0,
					userId: 0,
					disabled: false,
					adminOrUser: true,
					accessToRelativeGroup: true,
					email_Notification: false,
					smS_Notification: false,
					phoneNumber: null,
					emailAddress: null,
					mobile_Notification: false,
					emailValidated: false,
					phoneNumberValidated: false,
					validationKey: null
				},
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},

		},
		created() {

			this.GetLocaluserListItem();

		},

		methods: {

			GetLocaluserListItem() {
				this.$http.get("Task/GetUserItem")
					.then(data => {
						this.userModel = data.data;
						this.testData = data.data;
						if(this.userModel.emailAddress==null || this.userModel.emailAddress=="")
						{
							this.isNullEmail=true;
						}
						else{
							this.isNullEmail=false;
						}

						if(this.userModel.phoneNumber==null || this.userModel.phoneNumber=="")
						{
							this.isNullPhoneNumber=true;
						}
						else{
							this.isNullPhoneNumber=false;
						}
					});
			},
			CreateLocaluserList() {
				this.v$.$touch();
				if (!this.v$.$invalid) {
					this.$store.dispatch("UpdateUserProfile", this.userModel);
				}
			},
			SendResetEmail() {
				this.Loading = true;
				this.$http.get('Account/ResendEmail?email=' + this.userModel.emailAddress + "&isForgotPass=false").then(response => {
					console.log(response);
					if (response.data == 1) {
						this.showMessage("لینک فعالسازی به آدرس ایمیل شما ارسال شد.");
					}
					else {
						this.showErrorMessage(response.data);
						console.log(response);
					}
					this.Loading = false;
				}, data => {
					console.log(data);
				});
			},
			GetRegistCode() {
				this.Loading = true;

				this.$http.get('Account/ResendSms?phoneNumber=' + this.userModel.phoneNumber).then(response => {
					console.log(response);
					if (response.data == 1) {
						this.showRegistCode = true;
						this.setTimer();
					}
					else {
						this.showErrorMessage(response.data);
						console.log(response);
					}
					this.Loading = false;
				}, data => {
					console.log(data);
				});
			},
			ValidateCode() {
				if (this.registCode == "" || this.registCode == null) {
					this.invalidRegistCode = true;
					this.showErrorMessage("لطفا کد فعالسازی را وارد کنید");
					return;
				}
				this.Loading = true;
				this.$http.post('Account/ValidatePhoneNumber?phoneNumber=' + this.userModel.phoneNumber + '&registCode=' + this.registCode).then(response => {
					console.log(response);
					if (response.data != "1") {
						this.showErrorMessage(response.data);
					}
					else {
						this.showRegistCode = false;
						this.showMessage("فعالسازی شماره تلفت همراه با موفقیت انجام شد.")
					}
					this.Loading = false;
				}, data => {
					console.log(data);
				}, error => {
					console.log(error);
				});
			},
			setTimer() {
				var timer2 = "5:00";
				var interval = setInterval(function () {
					var timer = timer2.split(':');
					//by parsing integer, I avoid all extra string processing
					var minutes = parseInt(timer[0], 10);
					var seconds = parseInt(timer[1], 10);
					--seconds;
					minutes = (seconds < 0) ? --minutes : minutes;
					seconds = (seconds < 0) ? 59 : seconds;
					seconds = (seconds < 10) ? '0' + seconds : seconds;
					//minutes = (minutes < 10) ?  minutes : minutes;
					document.getElementById('resendButton').innerHTML = "ارسال مجدد کد " + minutes + ':' + seconds;
					//check if both minutes and seconds are 0
					if ((seconds <= 0) && (minutes <= 0)) {
						clearInterval(interval);
						document.getElementById('resendButton').disabled = false;
						document.getElementById('resendButton').innerHTML = "ارسال مجدد کد";
					}
					timer2 = minutes + ':' + seconds;
				}, 1000);
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
		},
		mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		},
		validations: {
			userModel: {
				emailAddress: {
					email
				},

			}


		},

	};
</script>
